import dynamic from 'next/dynamic';

const components = {
    CITA: dynamic(() => import(`./Cites`)),
    IMATGE: dynamic(() => import(`./ImatgeComponent`)),
    TEXT: dynamic(() => import(`./TextComponent`)),
    BLUESKY: dynamic(() => import(`./Embed`)),
    CARTO: dynamic(() => import(`./Embed`)),
    DATAWRAPPER: dynamic(() => import(`./Embed`)),
    EMBED: dynamic(() => import(`./Embed`)),
    FACEBOOK: dynamic(() => import(`./Embed`)),
    FLOURISH: dynamic(() => import(`./Embed`)),
    IFRAME_3CAT: dynamic(() => import(`./Embed`)),
    INFOGRAM: dynamic(() => import(`./Embed`)),
    INSTAGRAM: dynamic(() => import(`./Embed`)),
    QUALIFIO: dynamic(() => import(`./Embed`)),
    OPTA: dynamic(() => import(`./Embed`)),
    TIKTOK: dynamic(() => import(`./Embed`)),
    TWITTER: dynamic(() => import(`./Embed`)),
    YOUTUBE: dynamic(() => import(`./Embed`))
};

export { components };
